import React from 'react';
import OrganizationBreadcrumbs from './OrganizationBreadcrumbs';
import { useSearchParams } from 'react-router-dom';
import { FilterKeys } from '@common/enums/query-params/filters';
import { RobotIcon, UserIcon } from '@common/utils/icons/icons';

const TopBarHeaderText: React.FC = () => {
  const [filterParams] = useSearchParams();
  const queryRobotId = filterParams.get(FilterKeys.RobotId);
  const queryUserId = filterParams.get(FilterKeys.UserId);

  if (queryUserId != null) return <UserIcon color="action" />;

  if (queryRobotId != null) return <RobotIcon color="action" />;

  return <OrganizationBreadcrumbs />;
};

export default TopBarHeaderText;
